export const Select = {
  baseStyle: {},
  defaultProps: {
    size: 'md',
  },
  sizes: {
    md: {
      field: {
        paddingInlineEnd: 'min(48px, 20%)',
        borderRadius: '8px',
        height: '52px',
        fontSize: 'md',
      },
    },
    sm: {
      field: {
        paddingInlineEnd: 'min(48px, 20%)',
        borderRadius: '8px',
        height: '40px',
        fontSize: 'md',
      },
      element: {
        height: '40px',
      },
    },
    xs: {
      field: {
        paddingInlineEnd: 'min(48px, 20%)',
        borderRadius: '8px',
        height: '24px',
        fontSize: 'md',
      },
      element: {
        height: '24px',
      },
    },
  },
  variants: {
    outline: {
      field: {
        _focus: {
          borderWidth: '1px',
          borderColor: 'blue.700',
          boxShadow: 'focus',
        },
      },
    },
    success: {
      field: {
        borderWidth: '1px',
        borderColor: 'green.500',
        boxShadow: 'success',
        _focus: {
          borderWidth: '1px',
          borderColor: 'green.500',
          boxShadow: 'success',
        },
      },
    },
    error: {
      field: {
        borderWidth: '1px',
        borderColor: 'error.button',
        boxShadow: 'error',

        _focus: {
          borderWidth: '1px',
          borderColor: 'error.button',
          boxShadow: 'error',
        },
      },
    },
    disabled: {
      field: {
        opacity: 1,
        borderColor: 'grey.background',
        pointerEvents: 'none',
        backgroundColor: 'grey.border',
        background: 'grey.border',
        color: 'grey.primaryText',
      },
      icon: {
        color: 'transparent',
      },
    },
    ghost: {
      field: {
        backgroundColor: 'grey.white',
      },
    },
  },
};
